export * from './src/quickpages-v1-page-pages.universal.js';
